import { SearchPage } from 'components/pages/Search'
import { useRedirectSignedIn } from 'hooks/useRedirectSignedIn'

// /search is only for signed-out users; signed-in users go to their home page
const Search = () => {
	const redirecting = useRedirectSignedIn()
	if (redirecting) return null

	return <SearchPage />
}

export default Search
